<template>
  <div>
    <ClinicPatientsList />
  </div>
</template>

<script>
import ClinicPatientsList from "./ClinicPatientsList.vue";
import {
  BCard,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BButton,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BButton,
    ClinicPatientsList,
  },
  data() {
    return {
      patient: "",
    };
  },
};
</script>

<style>
.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>